<form>
  <mat-form-field appearance="outline" class="wide">
    <mat-label>{{ placeholder() }}</mat-label>
    <mat-select multiple [formControl]="filterControl">
      @for (option of options(); track option.label) {
        <mat-option [value]="option.value">{{option.label}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
